export default "__VITE_ASSET__06d9dd00__"